var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLectureRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000688556 0.517724V7.46018C0.000688556 9.03062 1.14468 10.2938 2.5345 10.2877H11.5282C11.6564 10.2814 11.7769 10.2239 11.8634 10.1279C11.9499 10.0319 11.9954 9.90504 11.9898 9.77515V2.83269C11.979 1.26347 10.8398 0.000318489 9.45123 0.00639132H0.457566C0.394341 0.00934436 0.332317 0.0249422 0.27507 0.0522857C0.217823 0.0796293 0.166485 0.118178 0.124015 0.16571C0.0815455 0.213242 0.0487832 0.268817 0.0276168 0.329233C0.00645038 0.389648 -0.00270152 0.453709 0.000688556 0.517724ZM13.424 3.22742L17.3884 0.175216C17.7326 -0.125996 18 -0.0506933 18 0.493432V9.80065C18 10.4201 17.6738 10.3448 17.3884 10.1189L13.424 7.07395V3.22742Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLectureRoom);
export default __webpack_public_path__ + "static/media/LectureRoom.2fa87c179dd219ddf5074d745bcd3c77.svg";
export { ForwardRef as ReactComponent };